import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Select, Input, Button } from 'antd'
import ConfirmButton from '@components/ConfirmButton'
import { users } from '@services/api'
import { validateEmail } from '@utils/index'
import * as styles from './styles.scss'
import EditRoles from '@components/EditRoles'

@inject((store: any) => {
    const { popupStore, authStore } = store

    return {
        popupStore,
        authStore
    }
})
@observer
export default class UserPopup extends Component<any, any> {
    state: any = {
        userInfo: {},
        errors: {}
    }

    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }

    setError = (errorName, errorMsg) => {
        this.props.popupStore.addErrors(errorName, errorMsg)
        return false
    }

    validateUser = () => {
        const { username, email, role, password, password_confirm } = this.props.popupStore.info

        if (!username) {
            return this.setError('userError', 'אנה הזן שם משתמש')
        } else {
            this.setError('userError', null)
        }

        if (!email) {
            return this.setError('emailError', 'אנה הזן כתובת מייל')
        } else if (!validateEmail(email)) {
            return this.setError('emailError', 'כתובת המייל אינה תקינה')
        } else {
            this.setError('emailError', null)
        }

        if (!role) {
            return this.setError('roleError', 'אנה בחר הרשאת משתמש')
        } else {
            this.setError('roleError', null)
        }

        if (this.props.popupStore.popupType === 'addUser' && !password) {
            return this.setError('passwordError', 'חובה להזין סיסמה')
        } else if (password && password.length < 6) {
            return this.setError('passwordError', 'אנה הזן סיסמה מעל 6 תווים')
        } else if (password && password !== password_confirm) {
            return this.setError('passwordError', 'סיסמאות לא תואמות')
        } else {
            this.setError('passwordError', null)
        }

        return true
    }

    saveUser = async () => {
        if (this.validateUser()) {
            try {
                if (this.props.popupStore.popupType === 'addUser') {
                    await users.addUser(this.props.popupStore.info)
                } else {
                    await users.updateUser(this.props.popupStore.info)
                }
                this.props.popupUpdated()
                this.closePopup()
            } catch (e) {
                if (e.response.status === 400) {
                    this.setError('serverErrors', e.response.data)
                    console.log(e.response)
                } else {
                    this.setError('serverErrors', [{ message: 'בעיה בחיבור לשרת' }])
                    console.log(e.response)
                }
            }
        }
    }

    setRoles = async roles => {

    }

    deleteUser = async id => {
        await users
            .deleteUser(id)
            .then(res => {
                if (res.status === 200) {
                    this.closePopup()
                    this.props.popupUpdated()
                }
            })
            .catch(e => {
                this.setError('serverErrors', e.response.data)
            })
    }

    setValue = (e, name) => {
        this.props.popupStore.editInfo(name, e)
    }

    render() {

        const { popupStore, authStore: { roles } } = this.props
        const { username, first_name, last_name, email, role, password, password_confirm, id, userRoles } = popupStore.info
        const { userError, emailError, passwordError, roleError, serverErrors } = popupStore.errors  
    
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                {popupStore.popupType === 'editUser' ? (
                    <ConfirmButton
                        confirmed={() => this.deleteUser(id)}
                        confirmQuestion="למחוק משתמש?"
                        buttonText="מחק משתמש"
                    />
                ) : (
                    ''
                )}
                <div style={{ float: 'left', display: 'inline-block' }}>
                    <Button onClick={this.closePopup}>ביטול</Button>
                    <Button type="primary" onClick={this.saveUser}>
                        {popupStore.popupType === 'addUser' ? 'הוסף' : 'שמור'}
                    </Button>
                </div>
            </div>
        )

        return (
            <Modal
                title={popupStore.popupType === 'addUser' ? 'הוספת משתמש' : 'עריכת משתמש'}
                visible={popupStore.popupType === 'addUser' || popupStore.popupType === 'editUser'}
                onCancel={this.closePopup}
                okText={popupStore.popupType === 'addUser' ? 'הוסף' : 'שמור'}
                cancelText="ביטול"
                footer={footerButtons}
            >
                {serverErrors ? <span className={styles.server_error}>{serverErrors[0].message}</span> : ''}

                <Input
                    placeholder="שם משתמש"
                    value={username}
                    autoComplete="off"
                    name="username"
                    onChange={e => this.setValue(e.target.value, 'username')}
                />
                {userError ? <span className={styles.error}>{userError}</span> : ''}

                <Input
                    placeholder="שם פרטי"
                    autoComplete="off"
                    value={first_name}
                    name="first_name"
                    onChange={e => this.setValue(e.target.value, 'first_name')}
                />

                <Input
                    placeholder="שם משפחה"
                    autoComplete="off"
                    value={last_name}
                    name="last_name"
                    onChange={e => this.setValue(e.target.value, 'last_name')}
                />

                <Input
                    placeholder="כתובת מייל"
                    autoComplete="off"
                    value={email}
                    name="email"
                    onChange={e => this.setValue(e.target.value, 'email')}
                />
                {emailError ? <span className={styles.error}>{emailError}</span> : ''}

                {roles.includes('admin') &&
                    <EditRoles width={'100%'} createUser={true} userId={id} userRoles={userRoles} setValue={this.setValue} />}

                {roleError ? <span className={styles.error}>{roleError}</span> : ''}
                <Input.Password
                    placeholder="סיסמה"
                    value={password}
                    autoComplete="new-password"
                    onChange={e => this.setValue(e.target.value, 'password')}
                />

                <Input.Password
                    placeholder="אישור סיסמה"
                    value={password_confirm}
                    autoComplete="new-password"
                    onChange={e => this.setValue(e.target.value, 'password_confirm')}
                />
                {passwordError ? <span className={styles.error}>{passwordError}</span> : ''}
            </Modal>
        )
    }
}
